import faqSearchTemplate from './faq-search.html';

@Inject('Responsive')
class FaqSearchController {
  constructor() {
    this.searchPhrase = '';
  }

  onChangeHandler() {
    this.search({
      phrase: this.searchPhrase.toLowerCase(),
    });
  }

  resetSearch() {
    this.searchPhrase = '';
    this.onChangeHandler();
  }
}

export default class FaqSearchComponent {
  constructor() {
    this.template = faqSearchTemplate;
    this.controller = FaqSearchController;
    this.bindings = {
      search: '&',
    };

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/faq/components/faq-search/faq-search-component.js